import React from 'react';
import { connect } from 'react-redux';
import { resourceApi } from '../utils/fetchUtil';
import { changeTab, fireInAppBrowserPlugin } from '../actions/environmentActions';
import HeaderSmall from '../Components/Header/HeaderSmall';
import {Card, CardHeader, CardTitle, CardText} from 'material-ui/Card';
import Paper from 'material-ui/Paper';
import Divider from 'material-ui/Divider';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import Phone from 'material-ui/svg-icons/communication/phone';
import Email from 'material-ui/svg-icons/communication/email';
import Web from 'material-ui/svg-icons/av/web';
import TabStrip  from '../Components/TabStrip';


class MyIncentives extends React.Component {

    constructor(props) {
        super(props);
    
        this.state = {
          incentives: []
        };
      }

  componentWillMount() {
      this.props.updateTab();
  }

    componentDidMount() {
        console.log("MyIncentives.js", this.props)
        this.loadIncentives()
    }

    loadIncentives = () => {

        var self = this;

        let config = {
            method: 'get',
            url: `member/incentives/${self.props.params.camm_id}`
        };
 
       resourceApi(config) 
        .then(function (response) {
            self.setState({ incentives: response.data })    
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    getContent(data) {
        return {__html: data};
    }
  
  render() {

    return (
        <div>
           <HeaderSmall title={this.props.pageName || "Information"} /> 
            <div className="container truenoLight" style={{marginTop: 20}}>
                <br />
                {(this.state.incentives) && (
                    this.state.incentives.map((item, index) => 
                        <div key={index}>
                             <Card>
                             <CardHeader
                             title={<h3>{item.Name}</h3>}
                             
                             subtitle={((item.Subtitle) ? item.Subtitle : null)}
                             avatar={((item.IconClass) ? <div className={item.IconClass} /> : null)}
                             actAsExpander={true}
                             showExpandableButton={true}
                             className="mjtest"
                            
                             />
                             <CardText expandable={true}>
                                 <div style={{fontSize:16}} dangerouslySetInnerHTML={this.getContent(item.Description)} />

                                 {(item.Phone) && (
                                      <a style={{ textDecoration:"none"}} onClick={()=>{fireInAppBrowserPlugin("tel:" + item.Phone)}} >
                                         <RaisedButton icon={<Phone />}  primary={true} fullWidth={true} label="Call"  />
                                     </a>
                                 )}

                                 {(item.Email) && (
                                      <a style={{ textDecoration:"none"}} onClick={()=>{fireInAppBrowserPlugin("mailto:" + item.Email)}} >
                                         <RaisedButton icon={<Email />}  primary={true} fullWidth={true} label="Email" />
                                     </a>
                                 )} 

                                 {(item.Url) && (
                                     <div>
                                         <RaisedButton icon={<Web />} onClick={() => {fireInAppBrowserPlugin(item.Url) }} primary={true} fullWidth={true} label="Access This Benefit" />                                
                                     </div>
                                 )}  
                             </CardText>
                         </Card>
                            <br />
                        </div>
                    )
                )}
                <br /><br /><br />
               
            </div>
            <TabStrip activeTab={29} /> 
        </div>
    );
  }
};

//export default MyBenefits;

const mapDispatchToProps = (dispatch) => {
  return {
    updateTab: () => {
      dispatch(changeTab("3"))
    }
  }
}

const mapStateToProps = (state) => ({
    incentives: state.thisApp.auth.incentives,
    pageName: state.thisApp.environment.pageName
})


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyIncentives)



// WEBPACK FOOTER //
// ./src/Pages/MyIncentives.js